import { Injectable } from '@angular/core';
import { BaseService } from '../core';
import { BuyerService } from './buyer.service';
import { ProductService } from './product.service';
import { BuyerCompany } from '../dto';

@Injectable({
  providedIn: 'root',
})
export class UDirectService extends BaseService {
  /** U-Direct 사용여부 */
  isUDirect = false;
  /** U-Direct 지역명 */
  uDirectZone = 'Europe';
  /** TAX, Busines Registration Number 입력 여부 */
  isTax = false;


  constructor(
    private buyerService:BuyerService,
    private productService:ProductService
  ){
    super()
  }
  /**
   * 유럽존여부 체크 - 메뉴바, 체크박스 활성화 여부 제어함
   */
  isEuropeDirect() {
    this.buyerService.getBuyer().subscribe(async (buyer) => {
      let UdirectArr = ['Europe'];     // U-Direct 포함될 국가
      this.isUDirect = UdirectArr.includes(buyer.buyerCompany.country.directRegion);
      if(this.isUDirect) this.uDirectZone = buyer.buyerCompany.country.directRegion;
      if(!this.isUDirect) this.productService.removeUdirectSelect(); // 일괄 등록에서 유다이렉트 상품 제거
    });
  }

  /**
   * home에서 사용될 buyer 정보
   * @returns BuyerCompany{vatNumber, businessNumber, certificateStatus, rejectedReason}
   */
  async getTaxInfo(): Promise<BuyerCompany>{
    return new Promise((res, rej) => {
      // 상태값, 반려사유, tax번호, eori번호
      this.buyerService.getBuyer().subscribe((buyer) => {
        res(new BuyerCompany({
          vatNumber: buyer.buyerCompany.vatNumber,
          vatAttachment: buyer.buyerCompany.vatAttachment,
          businessNumber: buyer.buyerCompany.businessNumber,
          businessAttachment: buyer.buyerCompany.vatAttachment,
          certificateStatus: buyer.buyerCompany.certificateStatus,
          rejectedReason: buyer.buyerCompany.rejectedReason
        }));
      });
    });
  }

  /**
   * cart에서 사용될 buyer 정보
   * @returns BuyerCompany{vatNumber, vatAttachment, businessNumber, businessAttachment, certificateStatus}
   */
  async wantBuyUdirect(): Promise<BuyerCompany>{
    return new Promise((res, rej) => {
      // VAT번호, VAT첨부파일, Business번호, Business첨부파일
      this.buyerService.getBuyer().subscribe((buyer) => {
        res(new BuyerCompany({
          vatNumber: buyer.buyerCompany.vatNumber,
          vatAttachment: buyer.buyerCompany.vatAttachment,
          businessNumber: buyer.buyerCompany.businessNumber,
          businessAttachment: buyer.buyerCompany.vatAttachment,
          certificateStatus: buyer.buyerCompany.certificateStatus
        }));
      });
    });
  }
}
